import { api } from './api';
import { decodeSafariRecording } from './safariPcm';
import { voiceError, voiceTrace } from './voiceDiagnostics';

const canRecover = error => error.code === 'TRANSCRIPTION_EMPTY_TEXT' || [400, 415, 422].includes(error.status);
const checkCancelled = signal => { if (signal?.aborted) throw voiceError('TRANSCRIPTION_CANCELLED', 'Recording cancelled.'); };

// Retry the SAME captured audio, never repeat recording or call the save flow
// twice. Successful native recordings and all non-Apple browsers stay unchanged.
export async function transcribeRecordedAudio(audio, { appleWebKit, signal, captureId, onPhase = () => {} }, client = api, decode = decodeSafariRecording) {
  try {
    const text = await client.transcribe(audio.blob, audio.extension, { signal, captureId, attempt: 'native' });
    voiceTrace('transcription-route', { captureId, recovery: 'native', textLength: text.length });
    return text;
  } catch (error) {
    if (!appleWebKit || !canRecover(error)) throw error;
  }
  checkCancelled(signal); onPhase('decoding');
  const pcm = await decode(audio.blob, { signal, captureId });
  checkCancelled(signal); onPhase('transcribing');
  const plain = pcm.toWav();
  voiceTrace('safari-wav-retry', { captureId, sourceMime: audio.mimeType, sourceBytes: audio.blob.size, mimeType: plain.type, blobBytes: plain.size, gain: 1 });
  try {
    const text = await client.transcribe(plain, 'wav', { signal, captureId, attempt: 'wav-plain' });
    voiceTrace('transcription-route', { captureId, recovery: 'wav-repack', gain: 1, textLength: text.length });
    return text;
  } catch (error) {
    if (error.code !== 'TRANSCRIPTION_EMPTY_TEXT' || !pcm.weak) throw error;
  }
  checkCancelled(signal);
  const raised = pcm.toWav(pcm.gain);
  voiceTrace('safari-level-retry', { captureId, mimeType: raised.type, blobBytes: raised.size, gain: pcm.gain, decodedRms: pcm.rms, decodedPeak: pcm.peak });
  const text = await client.transcribe(raised, 'wav', { signal, captureId, attempt: 'wav-level' });
  voiceTrace('transcription-route', { captureId, recovery: 'wav-level', gain: pcm.gain, textLength: text.length });
  return text;
}